module Client.Routing

open Elmish.UrlParser
open System

[<RequireQualifiedAccess>]
type PageRoute =
    | Login
    | Home
    | ResetPassword of Guid option
    | EnterMFA

let tryPGuid state =
    custom "pGuid" (Guid.TryParse >> function true, value -> Ok (Some value) | _ -> Ok None) state

module PageRoute = 
    let toPath = 
            function
            | PageRoute.Home -> "#home"
            | PageRoute.Login -> "#login"
            | PageRoute.EnterMFA -> "#mfa"
            | PageRoute.ResetPassword g ->
                sprintf "#reset-password%s"
                    (g |> Option.map (fun g -> sprintf "/%s" (g.ToString())) |> Option.defaultValue "")

let pageParser : Parser<PageRoute -> PageRoute, _> =
    oneOf [ 
        map PageRoute.Home (s "home")
        map PageRoute.Login (s "login")
        map PageRoute.ResetPassword (s "reset-password" </> tryPGuid)
        map (PageRoute.ResetPassword None) (s "reset-password")
        map PageRoute.EnterMFA (s "mfa")
    ]

let urlParser location = parseHash pageParser location